import { render, staticRenderFns } from "./RecycleScroller.vue?vue&type=template&id=4f81a784"
import script from "./RecycleScroller.vue?vue&type=script&lang=js"
export * from "./RecycleScroller.vue?vue&type=script&lang=js"
import style0 from "./RecycleScroller.vue?vue&type=style&index=0&id=4f81a784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports